import React from 'react';
import './ui.scss';

export const Select = ({ label, options = [], className = '', id, required, ...props }) => {
  const selectId = id || (label ? label.replace(/\s+/g, '-').toLowerCase() : undefined);
  return (
    <div className={`mb-2 ${className}`}>
      {label && (
        <label className="builder-label" htmlFor={selectId}>
          {label}
          {required && <span className="builder-label__required" aria-hidden="true">*</span>}
        </label>
      )}
      <select id={selectId} className="builder-ui-select form-select" required={required} {...props}>
        {options.map((opt) => (
          <option key={opt.value} value={opt.value}>{opt.label}</option>
        ))}
      </select>
      
    </div>
  );
};

export default Select;
